import React, { Component } from 'react';
import styled from '@emotion/styled';
import onClickOutside from 'react-onclickoutside';

import { Theme } from 'ui_system/theme';
import { t } from 'services/translation';
import PopoverSelector from './PopoverSelector';

export const Container = styled('div')`
  display: inline;
  color: ${Theme.colors.lightText};
  font-size: 14px;
`;

export const CurrentFilter = styled('div')`
  display: inline-block;
  position: relative;
  color: ${Theme.colors.black};
`;

export const Filter = styled('div')`
  display: inline;
  margin-left: 5px;
  color: black;
  cursor: pointer;
`;

export const ToggleIcon = styled('div')`
  margin-left: 5px;
  display: inline-block;

  /* CSS Triangles! */
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 8.7px 5px 0 5px;
  border-color: ${Theme.colors.line} transparent transparent transparent;
`;

const Showing = styled('div')`
  display: inline-block;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    display: none;
  }
`;

class TourFilter extends Component {
  static defaultProps = {
    filter: 'active',
    dropdownOptions: [
      { key: 'active', label: 'Active' },
      { key: 'archived', label: 'Archived' },
    ],
  };

  constructor(props) {
    super(props);

    this.state = {
      selectorOpen: false,
    };
  }

  handleClickOutside = (_e) => {
    this.closeSelector();
  };

  toggleSelector = () => {
    this.setState({ selectorOpen: !this.state.selectorOpen });
  };

  closeSelector = () => {
    this.setState({ selectorOpen: false });
  };

  render() {
    const { filter, selectFilter, noText, dropdownOptions } = this.props;
    const { selectorOpen } = this.state;

    let label = '';
    label = dropdownOptions?.find((option) => option.key === filter)?.label;

    return (
      <Container>
        {!noText && (
          <Showing data-testid="showing-filter">{t('SHOWING')}:</Showing>
        )}
        <Filter>
          <CurrentFilter
            onClick={this.toggleSelector}
            data-testid="tour-filter"
          >
            {t(label)}
            <ToggleIcon />

            <PopoverSelector
              open={selectorOpen}
              selectFilter={selectFilter}
              closeSelector={this.closeSelector}
              currentFilter={filter}
              dropdownOptions={dropdownOptions}
            />
          </CurrentFilter>
        </Filter>
      </Container>
    );
  }
}

export default onClickOutside(TourFilter);
